import type { IconSvgObject } from './types';

const ArrowDown04Icon: IconSvgObject = [
  ["path", { d: "M11.9999 14V4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11.9996 20L16 14H8L11.9996 20Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ArrowDown04Icon;
